import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    width: '100%',
  },
  recipientWrapper: {
    width: '100%',
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  checkBox: {
    marginBottom: theme.spacing(-1.375),
  },
  title: {
    fontSize: '14px',
    lineHeight: theme.spacing(2.625),
    color: '#444444',
    fontWeight: 500,
  },
  value: {
    fontSize: '14px',
    lineHeight: theme.spacing(2.625),
    color: theme.palette.labraText.secondaryDescription,
    fontWeight: 400,
  },
  divider: {
    backgroundColor: theme.palette.dividerV2.main,
  },
}))
